import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-10eb796e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "datastore-field-drawer",
  class: "card card-drawer background-fb datastore-drawer"
}
const _hoisted_2 = { class: "card-header header-label d-flex flex-row justify-content-between align-items-center" }
const _hoisted_3 = { class: "d-flex align-items-center gap-2" }
const _hoisted_4 = ["aria-label"]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 2 }
const _hoisted_7 = { key: 3 }
const _hoisted_8 = { class: "d-flex align-items-center gap-2" }
const _hoisted_9 = ["aria-label"]
const _hoisted_10 = ["aria-label"]
const _hoisted_11 = {
  key: 0,
  class: "card-body overflow-auto font-size-14"
}
const _hoisted_12 = { class: "d-flex align-items-center gap-2" }
const _hoisted_13 = ["id"]
const _hoisted_14 = { class: "datastore-field-type" }
const _hoisted_15 = {
  key: 0,
  class: "datastore-hint margin-top-10"
}
const _hoisted_16 = {
  key: 1,
  class: "card-body d-flex flex-column overflow-auto font-size-14"
}
const _hoisted_17 = { class: "margin-top-10 d-flex flex-column" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "color-red" }, "*", -1))
const _hoisted_19 = { class: "margin-top-10 d-flex flex-column" }
const _hoisted_20 = {
  key: 0,
  class: "margin-top-10 d-flex flex-column"
}
const _hoisted_21 = { class: "datastore-switch-row margin-top-20" }
const _hoisted_22 = { class: "datastore-switch-row" }
const _hoisted_23 = { class: "datastore-switch-row" }
const _hoisted_24 = { class: "d-flex align-items-center gap-1" }
const _hoisted_25 = {
  key: 1,
  class: "datastore-dry-run margin-top-10",
  id: "datastore-dry-run"
}
const _hoisted_26 = {
  key: 0,
  class: "datastore-dry-errors"
}
const _hoisted_27 = {
  key: 2,
  class: "footer card-footer d-flex justify-content-end align-items-center"
}
const _hoisted_28 = {
  key: 3,
  class: "footer card-footer d-flex justify-content-end align-items-center"
}
const _hoisted_29 = { class: "loader-div-sm" }
const _hoisted_30 = ["src"]

import { computed, reactive, ref } from "vue";
import {
  ElButton,
  ElDivider,
  ElInput,
  ElOption,
  ElSelect,
  ElSwitch,
  ElTable,
  ElTableColumn,
  ElTag,
  ElTooltip,
} from "element-plus";
import { TYPE } from "vue-toastification";
import { showAlert, showConfirm } from "@/core/popup";
import i18n from "@/core/i18n/i18n";
import { ASSETS_BASE_URL, DEFAULT_LOGO } from "@/core/logo";
import {
  ConvertPreview,
  DATASTORE_FIELD_TYPES,
  DataStoreField,
  DataStoreFieldType,
  DataStoreTable,
} from "@/datastore/types";
import {
  addField,
  canDataStore,
  convertPreview,
  deleteField,
  updateField,
} from "@/datastore/services/datastore.service";


export default /*#__PURE__*/_defineComponent({
  __name: 'FieldDesignerDrawer',
  props: {
    table: {}
  },
  emits: ["close", "changed"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const { t } = i18n.global;

const props = __props;
const emit = __emit;

const mode = ref<"list" | "edit">("list");
const editingField = ref<DataStoreField | null>(null);
const preview = ref<ConvertPreview | null>(null);
const previewLoading = ref(false);
const optionsText = ref("");
const form = reactive({
  name: "",
  type: "TEXT" as DataStoreFieldType,
  required: false,
  uniqueKey: false,
  dbIndex: false,
});

const sortedFields = computed(() =>
  [...props.table.fields].sort((a, b) => a.ordinal - b.ordinal)
);

function formatCount(n: number): string {
  return n.toLocaleString("en-US");
}

function openEditor(field: DataStoreField | null) {
  if (!canDataStore("TABLE.EDIT")) {
    showAlert(TYPE.ERROR, t("DataStore.NeedTableEdit"));
    return;
  }
  editingField.value = field;
  preview.value = null;
  form.name = field?.name ?? "";
  form.type = field?.type ?? "TEXT";
  form.required = field?.required ?? false;
  form.uniqueKey = field?.uniqueKey ?? false;
  form.dbIndex = field?.dbIndex ?? false;
  optionsText.value = field?.settings?.options?.join(", ") ?? "";
  mode.value = "edit";
}

async function onTypeChanged() {
  preview.value = null;
  const field = editingField.value;
  if (!field || form.type === field.type) return;
  previewLoading.value = true;
  try {
    preview.value = await convertPreview(props.table.id, field.id, form.type);
  } catch (e: any) {
    showAlert(TYPE.ERROR, e.message ?? t("Common.UnknownError"));
  } finally {
    previewLoading.value = false;
  }
}

async function onSave() {
  const name = form.name.trim();
  if (!name) {
    showAlert(TYPE.WARNING, t("DataStore.NameRequired"));
    return;
  }
  const settings =
    form.type === "SINGLE_SELECT"
      ? {
          options: optionsText.value
            .split(",")
            .map((s) => s.trim())
            .filter(Boolean),
        }
      : undefined;
  try {
    if (editingField.value) {
      const typeChanged = form.type !== editingField.value.type;
      await updateField(props.table.id, editingField.value.id, {
        name,
        type: form.type,
        required: form.required,
        uniqueKey: form.uniqueKey,
        dbIndex: form.dbIndex,
        settings,
      });
      showAlert(
        typeChanged ? TYPE.INFO : TYPE.SUCCESS,
        typeChanged ? t("DataStore.ConvertQueued") : t("DataStore.FieldSaved")
      );
    } else {
      await addField(props.table.id, {
        name,
        type: form.type,
        required: form.required,
        uniqueKey: form.uniqueKey,
        dbIndex: form.dbIndex,
        settings,
      });
      showAlert(TYPE.SUCCESS, t("DataStore.FieldAdded", { name }));
    }
    mode.value = "list";
    emit("changed");
  } catch (e: any) {
    showAlert(TYPE.ERROR, e.message ?? t("Common.UnknownError"));
  }
}

async function onDelete() {
  const field = editingField.value;
  if (!field) return;
  const confirmed = await showConfirm(
    "warning",
    t("DataStore.DeleteField"),
    t("DataStore.DeleteFieldWarning", { name: field.name })
  );
  if (!confirmed) return;
  try {
    await deleteField(props.table.id, field.id);
    showAlert(TYPE.WARNING, t("DataStore.FieldDeleted", { name: field.name }));
    mode.value = "list";
    emit("changed");
  } catch (e: any) {
    showAlert(TYPE.ERROR, e.message ?? t("Common.UnknownError"));
  }
}

__expose({ openEditor });

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (mode.value !== 'list')
          ? (_openBlock(), _createBlock(_unref(ElTooltip), {
              key: 0,
              effect: "custom",
              placement: "bottom",
              content: _unref(t)('Common.Back')
            }, {
              default: _withCtx(() => [
                _createElementVNode("button", {
                  id: "datastore-field-back",
                  type: "button",
                  class: "btn btn-link p-0",
                  "aria-label": _unref(t)('Common.Back'),
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (mode.value = 'list'))
                }, [
                  _createVNode(_component_font_awesome_icon, { icon: "arrow-left" })
                ], 8, _hoisted_4)
              ]),
              _: 1
            }, 8, ["content"]))
          : _createCommentVNode("", true),
        (mode.value === 'list')
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_unref(t)("DataStore.Fields")), 1))
          : (editingField.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_unref(t)("DataStore.FieldTitle", { name: editingField.value.name })), 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_unref(t)("DataStore.NewField")), 1)),
        (mode.value === 'list')
          ? (_openBlock(), _createBlock(_unref(ElTooltip), {
              key: 4,
              effect: "custom",
              placement: "bottom",
              content: _unref(t)('DataStore.OpaqueColumnsHint')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_font_awesome_icon, {
                  icon: "info-circle",
                  class: "datastore-info-icon"
                })
              ]),
              _: 1
            }, 8, ["content"]))
          : (editingField.value?.isPrimary)
            ? (_openBlock(), _createBlock(_unref(ElTooltip), {
                key: 5,
                effect: "custom",
                placement: "bottom",
                content: _unref(t)('DataStore.PrimaryFieldHint')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_font_awesome_icon, {
                    icon: "info-circle",
                    class: "datastore-info-icon"
                  })
                ]),
                _: 1
              }, 8, ["content"]))
            : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_8, [
        (mode.value !== 'list' && editingField.value && !editingField.value.isPrimary)
          ? (_openBlock(), _createBlock(_unref(ElTooltip), {
              key: 0,
              effect: "custom",
              placement: "bottom",
              content: _unref(t)('Common.Delete')
            }, {
              default: _withCtx(() => [
                _createElementVNode("button", {
                  id: "datastore-field-delete",
                  type: "button",
                  class: "btn btn-link datastore-danger-link p-0",
                  "aria-label": _unref(t)('Common.Delete'),
                  onClick: onDelete
                }, [
                  _createVNode(_component_font_awesome_icon, { icon: "trash" })
                ], 8, _hoisted_9)
              ]),
              _: 1
            }, 8, ["content"]))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          id: "datastore-field-drawer-close",
          type: "button",
          class: "btn btn-link p-0",
          "aria-label": _unref(t)('Common.Close'),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
        }, [
          _createVNode(_component_font_awesome_icon, { icon: "times" })
        ], 8, _hoisted_10)
      ])
    ]),
    _createVNode(_unref(ElDivider), { style: {"margin":"0"} }),
    (mode.value === 'list')
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createVNode(_unref(ElTable), {
            class: "oneTeg-table oneTeg-table--sm",
            data: sortedFields.value,
            "show-header": false,
            "row-class-name": "oneTeg-table-row-permission",
            "empty-text": _unref(t)('Common.NoData'),
            onRowClick: openEditor
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(ElTableColumn), null, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("strong", {
                      id: 'datastore-field-item-' + scope.row.id
                    }, _toDisplayString(scope.row.name), 9, _hoisted_13),
                    (scope.row.isPrimary)
                      ? (_openBlock(), _createBlock(_unref(ElTag), {
                          key: 0,
                          size: "small",
                          class: "datastore-primary-tag"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(t)("DataStore.Primary")), 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", _hoisted_14, _toDisplayString(scope.row.type), 1)
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data", "empty-text"]),
          (!_unref(canDataStore)('TABLE.EDIT'))
            ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(_unref(t)("DataStore.NeedTableEdit")), 1))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("label", null, [
              _createElementVNode("strong", null, [
                _createTextVNode(_toDisplayString(_unref(t)("DataStore.DisplayName")), 1),
                _hoisted_18
              ])
            ]),
            _createVNode(_unref(ElInput), {
              id: "datastore-field-name",
              modelValue: form.name,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.name) = $event)),
              size: "small"
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("label", null, [
              _createElementVNode("strong", null, _toDisplayString(_unref(t)("DataStore.Type")), 1)
            ]),
            _createVNode(_unref(ElSelect), {
              id: "datastore-field-type",
              modelValue: form.type,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.type) = $event)),
              size: "small",
              class: "width-100",
              onChange: onTypeChanged
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(DATASTORE_FIELD_TYPES), (ft) => {
                  return (_openBlock(), _createBlock(_unref(ElOption), {
                    key: ft,
                    label: ft,
                    value: ft
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          (form.type === 'SINGLE_SELECT')
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                _createElementVNode("label", null, [
                  _createElementVNode("strong", null, _toDisplayString(_unref(t)("DataStore.SelectOptions")), 1)
                ]),
                _createVNode(_unref(ElInput), {
                  id: "datastore-field-options",
                  modelValue: optionsText.value,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((optionsText).value = $event)),
                  size: "small",
                  placeholder: _unref(t)('DataStore.SelectOptionsPlaceholder')
                }, null, 8, ["modelValue", "placeholder"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("span", null, _toDisplayString(_unref(t)("DataStore.Required")), 1),
            _createVNode(_unref(ElSwitch), {
              id: "datastore-field-required",
              modelValue: form.required,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.required) = $event)),
              "active-color": "#5022a6",
              class: "element-switch-oneteg",
              width: 48
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("span", null, _toDisplayString(_unref(t)("DataStore.UniqueKey")), 1),
            _createVNode(_unref(ElSwitch), {
              id: "datastore-field-unique",
              modelValue: form.uniqueKey,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.uniqueKey) = $event)),
              "active-color": "#5022a6",
              class: "element-switch-oneteg",
              width: 48
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("span", _hoisted_24, [
              _createTextVNode(_toDisplayString(_unref(t)("DataStore.DatabaseIndex")) + " ", 1),
              _createVNode(_unref(ElTooltip), {
                effect: "custom",
                placement: "top",
                content: _unref(t)('DataStore.IndexHint')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_font_awesome_icon, {
                    icon: "info-circle",
                    class: "datastore-info-icon"
                  })
                ]),
                _: 1
              }, 8, ["content"])
            ]),
            _createVNode(_unref(ElSwitch), {
              id: "datastore-field-index",
              modelValue: form.dbIndex,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((form.dbIndex) = $event)),
              "active-color": "#5022a6",
              class: "element-switch-oneteg",
              width: 48
            }, null, 8, ["modelValue"])
          ]),
          (preview.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                _createElementVNode("div", null, [
                  _createVNode(_component_font_awesome_icon, {
                    icon: "info-circle",
                    class: "color-warning margin-right-10"
                  }),
                  _createElementVNode("b", null, _toDisplayString(_unref(t)("DataStore.DryRun")) + ":", 1),
                  _createTextVNode(" " + _toDisplayString(editingField.value?.type) + " → " + _toDisplayString(form.type) + " " + _toDisplayString(_unref(t)("DataStore.DryRunOn", { total: formatCount(preview.value.total) })), 1)
                ]),
                _createElementVNode("div", null, _toDisplayString(_unref(t)("DataStore.DryRunFailing", {
              failing: formatCount(preview.value.failing),
            })), 1),
                (preview.value.sampleErrors.length)
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_26, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(preview.value.sampleErrors, (err, i) => {
                        return (_openBlock(), _createElementBlock("li", { key: i }, _toDisplayString(err), 1))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ])),
    (mode.value === 'list')
      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
          (_unref(canDataStore)('TABLE.EDIT'))
            ? (_openBlock(), _createBlock(_unref(ElButton), {
                key: 0,
                id: "datastore-add-field-button",
                class: "btn-oneTeg2",
                size: "small",
                onClick: _cache[8] || (_cache[8] = ($event: any) => (openEditor(null)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)("DataStore.AddField")), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_28, [
          _createVNode(_unref(ElButton), {
            id: "datastore-field-save",
            class: "btn-oneTeg2",
            size: "small",
            onClick: onSave
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(editingField.value ? _unref(t)("Common.Save") : _unref(t)("DataStore.CreateField")), 1)
            ]),
            _: 1
          })
        ])),
    _withDirectives(_createElementVNode("div", _hoisted_29, [
      _createElementVNode("img", {
        src: `${_unref(ASSETS_BASE_URL)}/${_unref(DEFAULT_LOGO)}.png`,
        alt: "Loading...",
        class: "loader-logo-40"
      }, null, 8, _hoisted_30)
    ], 512), [
      [_vShow, previewLoading.value]
    ])
  ]))
}
}

})